import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { IconButton, Stack, Edit03Icon } from '@metarouter-private/mr-mui';

import { routes } from 'app/constants';

const STACK_PROPS = {
  alignItems: 'center',
  direction: 'row',
};

export default function ActionsCell({ row }) {
  const { pipeline } = row;

  const to = {
    pathname: routes.analyticsJSBuilder,
    state: {
      pipelineId: pipeline.id,
      writekey: pipeline.writekey,
      name: pipeline.name,
      clusterId: pipeline.clusterId,
      clusterName: pipeline.cluster.name,
      referrer: routes.analyticsFiles,
    },
  };

  return (
    <Stack {...STACK_PROPS}>
      <IconButton component={Link} to={to} size="small" data-test-id="edit-analytics-file-button">
        <Edit03Icon fontSize="small" />
      </IconButton>
    </Stack>
  );
}

ActionsCell.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string,
    pipeline: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      writekey: PropTypes.string,
      clusterId: PropTypes.string,
      cluster: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
};
